let viewportsConfig = [
  {
    rule: "320px",
    label: "mobile"
  },
  {
    rule: "769px",
    label: "tablet"
  },
  {
    rule: "1024px",
    label: "desktop"
  },
  {
    rule: "1216px",
    label: "widescreen"
  },
  {
    rule: "1408px",
    label: "fullhd"
  }
]

let pageIsTouch = viewportsInstance => {
  return ["mobile", "tablet"].includes(viewportsInstance.label)
}

export default viewportsConfig

export { pageIsTouch }
